export default "__VITE_ASSET__gI_5CfpM__"